// Estado de las vistas (búsquedas, filtros y orden de las tablas) que se conserva mientras dure
// la sesión, para que al ir a otra página y regresar no se pierda lo que el usuario había
// aplicado. Se guarda en sessionStorage, en una sola llave ('viewState') con un objeto cuyas
// claves son el centro y el perfil activos más el nombre de cada dato; así lo que se aplicó en
// un centro o perfil no se mezcla con otro. Todas las funciones son síncronas y silenciosas: si
// sessionStorage no está disponible, la vista simplemente no conserva nada.

const VIEW_STATE_KEY = 'viewState'

/**
 * Prefijo con el centro y el perfil activos del usuario ("1-2" = centro 1, perfil 2).
 */
const GetNamespace = () => {
    try {
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        const idCenter = userData?.navigation?.center?.id ?? 0
        const idRole = userData?.navigation?.role?.id ?? 0

        return `${idCenter}-${idRole}`
    } catch {
        return '0-0'
    }
}

const ReadAll = () => {
    try {
        const parsed = JSON.parse(sessionStorage.getItem(VIEW_STATE_KEY))

        return parsed && typeof parsed === 'object' ? parsed : {}
    } catch {
        return {}
    }
}

/**
 * Obtiene un dato guardado de una vista.
 *
 * @param {string} key - Nombre del dato, por ejemplo "groups.searchVisible".
 * @param {*} fallback - Valor que se regresa si no hay nada guardado.
 */
const GetViewState = (key, fallback) => {
    const all = ReadAll()
    const fullKey = `${GetNamespace()}:${key}`

    return Object.prototype.hasOwnProperty.call(all, fullKey) ? all[fullKey] : fallback
}

/**
 * Guarda un dato de una vista (debe poder convertirse a JSON).
 */
const SaveViewState = (key, value) => {
    try {
        const all = ReadAll()
        all[`${GetNamespace()}:${key}`] = value

        sessionStorage.setItem(VIEW_STATE_KEY, JSON.stringify(all))
    } catch {
        // Sin sessionStorage la vista simplemente no conserva el dato
    }
}

/**
 * Borra todo el estado de las vistas (al iniciar o cerrar sesión).
 */
const DeleteViewState = () => {
    try {
        sessionStorage.removeItem(VIEW_STATE_KEY)
    } catch {
        // Nada que hacer si sessionStorage no está disponible
    }
}

export { GetViewState, SaveViewState, DeleteViewState }
